import React from "react";
import LogIn from "../../organisms/InitialPagesComponents/LogIn/LogIn";

const LoginPage = () => {
  return <LogIn />;
};

export default LoginPage;
